import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { ApiRoutes } from "../../../services/apiroutes";
import { DocumentTypeModel } from "./document_type.model";
import { BackendListModel } from "../../../models/common/list.model";
import { Observable } from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class FileFieldService {
  base_url = ApiRoutes.DocumentType;

  constructor(private http: HttpClient) {
  }

  getDocumentTypes(group = null): Observable<BackendListModel<DocumentTypeModel>> {
    let url = `${this.base_url}`;

    let urlObj = new URL(url);
    if (group) {
      urlObj.searchParams.append('group', group);
    }

    return this.http.get<BackendListModel<DocumentTypeModel>>(String(urlObj));
  }

  getDocumentTypeById(id: string): Observable<DocumentTypeModel> {
    let url = `${this.base_url}${id}/`;
    return this.http.get<DocumentTypeModel>(url);
  }

  getDocumentTypeByDevName(devName: string) {
    let url = `${this.base_url}by_dev_name/${devName}/`;
    return this.http.get<DocumentTypeModel>(url);
  }
}

